import React, { useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import { FormDataConsumer, required, useResourceContext, useTranslate } from 'react-admin';
import { FileInput, FileField, ImageInput, ImageField, TextInput, TextField, useRecordContext, Labeled } from 'react-admin';
import { Box, Typography, Card, CardContent, IconButton, Grid, Link } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import { useFormContext } from "react-hook-form";
import {evaluateCondition} from "./evaluateCondition";

const applyTemplate = (tpl, record) =>
  tpl.replace(/\{([\w.]+)\}/g, (_, path) => {
    const parts = path.split('.');
    let val = record;
    for (const p of parts) val = val?.[p];
    return encodeURIComponent(val ?? '');
  });

export const AttachmentInput = ({
  field_meta,
  source_name,
  index,
  is_required,
}) => {
  const meta = JSON.parse(field_meta);
  const allowedMimeTypes = meta.mimetypes || ['image/png', 'image/jpeg', 'application/pdf'];
  const allowMultiple = meta.multi || false;
  const columns = meta.columns || ['name', 'description'];
  const requiredField = meta.requiredField || null;
  const requiredValue = meta.requiredValue || null;
  const dependField = meta.depend || null;
  const dependValue = meta.dependValue || null;
  const isImageUpload = meta.isImage || false;
  const resource = useResourceContext();
      const translate = useTranslate();
      const watchField = meta.watchField || null;
      const watchValue = meta.watchValue || null;
      const { setValue, getValues } = useFormContext();

  

  // Prepare the accept attribute in the required format
  const accept = allowedMimeTypes.reduce((acc, mimeType) => {
    acc[mimeType] = [`.${mimeType.split('/')[1]}`];
    return acc;
  }, {});

  const validateFileType = (value) => {
    if (value && Array.isArray(value)) {
      for (const file of value) {
        if (file.hasOwnProperty("rawFile") && !meta.mimetypes.includes(file.rawFile.type)) {
          return 'نوع احد الملفات المرفوعة غير مسموح بة يجب ان يكون من الملفات المحددة للحقل';
        }
      }
    }
    return undefined;
  };

  const removeFile = (fileIndex) => {
    const updatedFiles = [...(getValues(source_name) || [])];
    updatedFiles.splice(fileIndex, 1);
    setValue(source_name, updatedFiles);
  };


  console.log(allowedMimeTypes);
  return (
    <FormDataConsumer>
      {({ formData }) => {

        const dependent_value = dependField ? formData[dependField] : null;
        const required_value = requiredField ? formData[requiredField] : null;
        const showIf = dependField ? dependent_value === dependValue : true;
        const isRequired = requiredField ? required_value === requiredValue : false;
        const watched_value = watchField && formData[watchField] ? formData[watchField] : null;
        const isDisabled = watchField && formData[watchField] ? watched_value === watchValue : false;


        const validations = [];
        if (is_required || isRequired) {
          validations.push(required());
        }


        if (!showIf) return null;

  
        return (
          <Box sx={{ mt: 2, p: 3, border: '1px solid #ddd', borderRadius: 2, backgroundColor: '#f9f9f9' }}>
            {isImageUpload ? (
              <ImageInput
                fullWidth
                validate={[...validations, validateFileType]}
                source={source_name}
                key={index}
                accept={accept}

                multiple={allowMultiple}
                disabled={isDisabled}

              />
            ) : (
              <FileInput
                fullWidth
                validate={[...validations, validateFileType]}
                source={source_name}
                key={index}
                accept={accept}
                multiple={allowMultiple}
                disabled={isDisabled}

              />
            )}

            <Grid container spacing={2} sx={{ mt: 2, display: 'flex', flexWrap: 'wrap' }}>
              {Array.isArray(formData[source_name]) &&
                formData[source_name].map((file, fileIndex) => (
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={fileIndex}>
                    <Card sx={{ p: 2, textAlign: 'center', minWidth: 250, position: 'relative' }}>
                      <IconButton
                        onClick={() => removeFile(fileIndex)}
                        sx={{ position: 'absolute', top: 5, right: 5 }}
                        disabled={isDisabled}

                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                      <CardContent>
                        <Typography variant="subtitle1">ملف {fileIndex + 1}</Typography>
                        {file.src ? (
                          isImageUpload ? (
                            <ClickableImage record={file} source="src" />
                          ) : (
                            <FileField source="src" record={file} title="تحميل الملف مرفوع" target="_blank" />
                          )
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            لا يوجد ملف متاح
                          </Typography>
                        )}
                        {columns.map((col) => (
                          <TextInput
                            key={col}
                            source={`${source_name}[${fileIndex}].${col}`}
                            label={translate(`resources.${resource}.fields.${source_name}_${col}`)}
                            fullWidth
                            readOnly={isDisabled}

                          />
                        ))}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
            </Grid>
          </Box>
        );
      }}
    </FormDataConsumer>
  );
};


export const AdvancedAttachmentInput = ({
  field_meta,
  source_name,
  index,
  is_required,
}) => {
  const meta = JSON.parse(field_meta);
  const allowedMimeTypes = meta.mimetypes || ['image/png', 'image/jpeg', 'application/pdf'];
  const allowMultiple = meta.multi || false;
  const columns = meta.columns || ['name', 'description'];
  const requiredConditions = meta.requiredConditions || [];
  const logic = meta.logic || 'AND';
  const dependField = meta.depend || null;
  const dependValue = meta.dependValue || null;
  const isImageUpload = meta.isImage || false;
  const watchField = meta.watchField || null;
  const watchValue = meta.watchValue || null;
  const urlTemplate = meta.urlTemplate || null;




  const resource = useResourceContext();
  const translate = useTranslate();

  const accept = allowedMimeTypes.reduce((acc, mimeType) => {
    acc[mimeType] = [`.${mimeType.split('/')[1]}`];
    return acc;
  }, {});

  const validateFileType = (value) => {
    if (value && Array.isArray(value)) {
      for (const file of value) {
        if (file.hasOwnProperty("rawFile") && !meta.mimetypes.includes(file.rawFile.type)) {
          return 'نوع احد الملفات المرفوعة غير مسموح بة يجب ان يكون من الملفات المحددة للحقل';
        }
      }
    }
    return undefined;
  };

  return (
    <FormDataConsumer>
      {({ formData }) => {
        const { setValue, getValues } = useFormContext();
        const dependentValue = dependField ? formData[dependField] : null;
        const showIf = dependField ? dependentValue === dependValue : true;
        const watched_value = watchField ? formData[watchField] : null;


        if (!showIf) return null;

        const isRequired = evaluateCondition(formData, requiredConditions, logic);
        const validations = is_required || isRequired ? [required()] : [];
        const isDisabled = watchField ? watched_value === watchValue : false;


        const removeFile = (fileIndex) => {
          const updatedFiles = [...(getValues(source_name) || [])];
          updatedFiles.splice(fileIndex, 1);
          setValue(source_name, updatedFiles);
        };

        return (
          <Box sx={{ mt: 2, p: 3, border: '1px solid #ddd', borderRadius: 2, backgroundColor: '#f9f9f9' }}>
            {urlTemplate && (
              <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <DownloadIcon color="primary" />
                <Link
                  href={applyTemplate(urlTemplate, formData)}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ textDecoration: 'none', fontWeight: 'bold' }}
                >
                  اضغط هنا لتحميل قالب النموذج
                </Link>
              </Box>
            )}
            
            {isImageUpload ? (
              <ImageInput
                fullWidth
                validate={[...validations, validateFileType]}
                source={source_name}
                key={index}
                accept={accept}
                multiple={allowMultiple}
                disabled={isDisabled}

              />
            ) : (
              <FileInput
                fullWidth
                validate={[...validations, validateFileType]}
                source={source_name}
                key={index}
                accept={accept}
                multiple={allowMultiple}
                disabled={isDisabled}

              />
            )}

            <Grid container spacing={2} sx={{ mt: 2, display: 'flex', flexWrap: 'wrap' }}>
              {Array.isArray(formData[source_name]) &&
                formData[source_name].map((file, fileIndex) => (
                  <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={fileIndex}>
                    <Card sx={{ p: 2, textAlign: 'center', minWidth: 250, position: 'relative' }}>
                      <IconButton
                        onClick={() => removeFile(fileIndex)}
                        sx={{ position: 'absolute', top: 5, right: 5 }}
                        disabled={isDisabled}

                      >
                        <DeleteIcon color="error" />
                      </IconButton>
                      <CardContent>
                        <Typography variant="subtitle1">ملف {fileIndex + 1}</Typography>
                        {file.src ? (
                          isImageUpload ? (
                            <ClickableImage record={file} source="src" />
                          ) : (
                            <FileField source="src" record={file} title="تحميل الملف مرفوع" target="_blank" />
                          )
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            لا يوجد ملف متاح
                          </Typography>
                        )}
                        {columns.map((col) => (
                          <TextInput
                            key={col}
                            source={`${source_name}[${fileIndex}].${col}`}
                            label={translate(`resources.${resource}.fields.${source_name}_${col}`)}
                            fullWidth
                          />
                        ))}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
            </Grid>
          </Box>
        );
      }}
    </FormDataConsumer>
  );
};

export const AttachmentPreview = ({ field_meta, source_name }) => {
  const meta = JSON.parse(field_meta);
  const columns = meta.columns || ['name', 'description'];
  const dependField = meta.depend || null;
  const dependValue = meta.dependValue || null;
  const isImagePreview = meta.isImage || false;
  const translate = useTranslate();
  const resource = useResourceContext();
  const record = useRecordContext();

  if (!record) return null;

  const dependent_value = dependField ? record[dependField] : null;
  const showIf = dependField ? dependent_value === dependValue : true;
  if (!showIf) return null;

  const files = Array.isArray(record[source_name]) ? record[source_name] : [record[source_name]].filter(Boolean);
  console.log(files);

  return (
    <Box sx={{ mt: 2, p: 3, border: '1px solid #ddd', borderRadius: 2, backgroundColor: '#f9f9f9' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
        {translate(`resources.${resource}.fields.${source_name}`)}
      </Typography>

      <Grid container spacing={2} sx={{ mt: 2, display: 'flex', flexWrap: 'wrap' }}>
        {files.map((file, fileIndex) => (
          <Grid item size={{ xs: 12, sm: 6, md: 4 }} key={fileIndex}>
            <Card sx={{ p: 2, textAlign: 'center', minWidth: 250, position: 'relative' }}>
              <CardContent>
                <Typography variant="subtitle1">ملف {fileIndex + 1}</Typography>
                {file.src ? (
                  isImagePreview ? (
                    <ClickableImage record={file} source="src" />
                  ) : (
                    <FileField source="src" record={file} title="تحميل الملف" target="_blank" />
                  )
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    لا يوجد ملف متاح
                  </Typography>
                )}

                {columns.map((col) => (
                  <Typography variant="body2" color="textSecondary" key={col}>
                    <Labeled>
                      <TextField
                        source={`${source_name}[${fileIndex}].${col}`}
                        label={translate(`resources.${resource}.fields.${source_name}_${col}`)}
                        value={file[col]}
                      />
                    </Labeled>
                  </Typography>
                ))}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};


const ClickableImage = ({ record, source }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box onClick={() => setOpen(true)} sx={{ cursor: 'pointer', display: 'inline-block' }}>
        <ImageField source={source} record={record} />
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <DialogContent>
          <img
            src={record[source]}
            style={{ width: '100%', height: 'auto' }}
            alt="Expanded Preview"
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
